<mat-toolbar color="primary">
  <span id="medlem-importer-dialog-tittel">{{ "Importer medlemmer"|translate }}</span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

<mat-dialog-content class="skjema e2e-medlemimporterdialog">

  <div class="importtype">
    <mat-button-toggle-group [formControl]="importType">
      <mat-button-toggle value="regneark" data-testid="importer-fra-regneark">{{ 'Importer fra regneark'|translate }}</mat-button-toggle>
      <mat-button-toggle value="gruppe" data-testid="importer-fra-gruppe">{{ 'Importer fra annen gruppe'|translate }}</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <medlem-importer-fra-regneark [gruppeId]="gruppe.id" [medlemsroller]="medlemsroller()" [hidden]="importType.value != 'regneark'"/>
  <medlem-importer-fra-gruppe [gruppeId]="gruppe.id" [medlemsroller]="medlemsroller()" [hidden]="importType.value != 'gruppe'"/>

</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-button (click)="avbryt()">{{ "Avbryt"|translate }}</button>
  <button mat-raised-button
          color="primary"
          (click)="importer()"
          cdkFocusInitial
          [visSpinner]="lagrer()"
          [disabled]="lagrer() || antallLinjerValgt()<1 || aktivKontroller()?.skjema.invalid"
          spinnerTekst="{{'Importerer...'|translate}}"
          class="e2e-opprett-møte">
    {{ "Registrer {antall} nye medlemmer"|translate: {antall: antallLinjerValgt()} }}
  </button>

  <mat-slide-toggle [formControl]="sendInvitasjon" data-testid="send-invitasjonsepost"
                    matTooltip="{{'Skru av denne dersom du ikke ønsker at systemet sender en e-post med invitasjon til alle inviterte'|translate}}">
    {{'Send invitasjons-e-post'|translate}}
  </mat-slide-toggle>

  <mat-slide-toggle [formControl]="sendInnkallingTilMoeter" data-testid="send-innkalling-til-moeter-epost"
                    matTooltip="{{'Dersom du velger \'Deltar som standard\' så vil det sendes innkalling til møtene for dette medlemmet'|translate}}">
    @if (antallMoeterDetSkalSendesInnkallingTilMoeter() == 1) {
      {{ 'Send innkalling til 1 møte'|translate }}
    } @else {
      {{ 'Send innkalling til {antallMoter} møter'|translate: {antallMoter: antallMoeterDetSkalSendesInnkallingTilMoeter()} }}
    }
  </mat-slide-toggle>
</mat-dialog-actions>
